"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _reactPopperTooltip = require("react-popper-tooltip");

var _ = require(".");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["tooltip", "placement", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Tooltip = function Tooltip(_ref) {
  var tooltip = _ref.tooltip,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      children = _ref.children,
      config = _objectWithoutProperties(_ref, _excluded);

  var _usePopperTooltip = (0, _reactPopperTooltip.usePopperTooltip)(_objectSpread({
    placement: placement
  }, config)),
      getArrowProps = _usePopperTooltip.getArrowProps,
      getTooltipProps = _usePopperTooltip.getTooltipProps,
      setTooltipRef = _usePopperTooltip.setTooltipRef,
      setTriggerRef = _usePopperTooltip.setTriggerRef,
      visible = _usePopperTooltip.visible;

  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_.Box, {
      ref: setTriggerRef,
      sx: {
        display: 'inline-block'
      },
      children: children
    }), visible && (0, _jsxRuntime.jsxs)(_.Flex, _objectSpread(_objectSpread({
      ref: setTooltipRef,
      flexDirection: "column",
      px: "2",
      py: "1",
      backgroundColor: "tooltip.background",
      sx: {
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.18)',
        borderRadius: 'small',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'tooltip.border',
        zIndex: '9999',
        '&[data-popper-interactive="false"]': {
          pointerEvents: 'none'
        },
        '&[data-popper-placement*="bottom"] > .arrow': {
          top: '0',
          left: '0',
          marginTop: '-0.4rem',
          '::before': {
            borderColor: 'transparent',
            borderBottomColor: 'tooltip.border',
            borderWidth: '0 0.5rem 0.4rem 0.5rem',
            position: 'absolute',
            top: '-1px'
          },
          '::after': {
            borderColor: 'transparent',
            borderBottomColor: 'tooltip.background',
            borderWidth: '0 0.5rem 0.4rem 0.5rem'
          }
        },
        '&[data-popper-placement*="top"] > .arrow': {
          bottom: '0',
          left: '0',
          marginBottom: '-1rem',
          width: '1rem',
          '::before': {
            borderColor: 'transparent',
            borderTopColor: 'tooltip.border',
            borderWidth: '0.4rem 0.5rem 0 0.5rem',
            position: 'absolute',
            top: '1px'
          },
          '::after': {
            borderColor: 'transparent',
            borderTopColor: 'tooltip.background',
            borderWidth: '0.4rem 0.5rem 0 0.5rem'
          }
        },
        '&[data-popper-placement*="left"] > .arrow': {
          right: '0',
          marginRight: '-0.7rem',
          width: '1rem',
          height: '1rem',
          '::before': {
            borderColor: 'transparent',
            borderLeftColor: 'tooltip.border',
            borderWidth: '0.5rem 0 0.5rem 0.4em'
          },
          '::after': {
            borderColor: 'transparent',
            borderLeftColor: 'tooltip.background',
            borderWidth: '0.5rem 0 0.5rem 0.4em',
            left: '3px',
            top: '0'
          }
        },
        '&[data-popper-placement*="right"] > .arrow': {
          left: '0',
          marginLeft: '-0.7rem',
          width: '1rem',
          height: '1rem',
          '::before': {
            borderColor: 'transparent',
            borderRightColor: 'tooltip.border',
            borderWidth: '0.5rem 0.4rem 0.5rem 0'
          },
          '::after': {
            borderColor: 'transparent',
            borderRightColor: 'tooltip.background',
            borderWidth: '0.5rem 0.4rem 0.5rem 0',
            left: '6px',
            top: '0'
          }
        }
      }
    }, getTooltipProps()), {}, {
      children: [typeof tooltip === 'string' ? (0, _jsxRuntime.jsx)(_.Body, {
        children: tooltip
      }) : tooltip, (0, _jsxRuntime.jsx)(_.Box, _objectSpread({
        width: "1rem",
        height: "1rem",
        sx: {
          pointerEvents: 'none',
          '::before': {
            borderStyle: 'solid',
            content: "''",
            display: 'block',
            width: '0',
            height: '0',
            margin: 'auto'
          },
          '::after': {
            borderStyle: 'solid',
            content: "''",
            display: 'block',
            width: '0',
            height: '0',
            margin: 'auto',
            position: 'absolute'
          }
        }
      }, getArrowProps({
        className: 'arrow'
      })))]
    }))]
  });
};

exports.Tooltip = Tooltip;